import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';
import { MenuItemModel } from '../models/menu/menu-item.model';
import { MenuItemStylingModel } from '../models/menu/menu-item-styling.model';

export const /** @type {?} */ MenuItemTemplates = {
  defaultTemplate: {
    property: new MenuItemModel({
      display: true,
      disable: false,
      buttonProperty: new ButtonModel({
        label: '',
        iconProperty: null,
        iconPosition: 'left'
      }),
      notification: null,
      divider: true
    }),
    style: new MenuItemStylingModel({
      container: { class: '', dynamicClass: '', themeColor: 'primary' },
      icon: { class: 'cf-default-icon', themeColor: 'primary' }
    })
  }
}
